/* ps-product-card.js (PERF) - swatches(color/size) + width-based "+N more"
   + Multi-option products: CTA routes to product page (Select options)
   + Single-option products: AJAX add -> redirect to /cart (faster)
   ✅ 개선: 스와치로 이미지 교체 시 srcset 제거하지 않고, Shopify width 기반 src/srcset 갱신
*/
(function () {
  if (window.__psProductCardScriptLoaded) return;
  window.__psProductCardScriptLoaded = true;

  const qs = (root, sel) => (root ? root.querySelector(sel) : null);
  const qsa = (root, sel) => (root ? Array.from(root.querySelectorAll(sel)) : []);

  function getOptionsCount(card) {
    const n = parseInt((card && card.getAttribute('data-ps-options-count')) || '0', 10);
    return Number.isFinite(n) ? n : 0;
  }

  function isMultiOptionProduct(card) {
    return getOptionsCount(card) > 1;
  }

  function getCardUrl(card) {
    return (card && card.getAttribute('data-ps-card-url')) || '';
  }

  // ✅ 폭 기반으로 "들어갈 만큼만" 표시 + "+N more"
  function layoutSwatchesByWidth(card) {
    const wrap = qs(card, '[data-ps-swatches]');
    if (!wrap) return;

    const moreEl = qs(card, '[data-ps-swatches-more]');
    if (!moreEl) return;

    const btns = qsa(wrap, '[data-ps-swatch]');
    if (!btns.length) {
      if (moreEl.style.display !== 'none') moreEl.style.display = 'none';
      if (moreEl.textContent) moreEl.textContent = '';
      return;
    }

    if (moreEl.style.display !== 'none') moreEl.style.display = 'none';
    if (moreEl.textContent) moreEl.textContent = '';

    for (let i = 0; i < btns.length; i++) {
      const b = btns[i];
      if (b.style.display === 'none') b.style.display = '';
    }

    const wrapWidth = wrap.clientWidth;
    if (!wrapWidth) return;

    let gap = 5;
    const cs = window.getComputedStyle(wrap);
    const g = parseFloat(cs.columnGap || cs.gap || '0');
    if (!Number.isNaN(g) && g > 0) gap = g;

    const reserveForMore = 72;

    const widths = new Array(btns.length);
    for (let i = 0; i < btns.length; i++) {
      widths[i] = btns[i].offsetWidth;
    }

    let used = 0;
    let shown = 0;

    for (let i = 0; i < widths.length; i++) {
      const bw = widths[i];
      const willHaveRemain = i < widths.length - 1;
      const limitWidth = willHaveRemain ? wrapWidth - reserveForMore : wrapWidth;

      const nextUsed = shown === 0 ? bw : used + gap + bw;

      if (nextUsed <= limitWidth) {
        used = nextUsed;
        shown++;
      } else {
        break;
      }
    }

    if (shown < 1) shown = 1;

    const remain = Math.max(btns.length - shown, 0);

    for (let i = 0; i < btns.length; i++) {
      const shouldShow = i < shown;
      const curHidden = btns[i].style.display === 'none';
      if (shouldShow && curHidden) btns[i].style.display = '';
      if (!shouldShow && !curHidden) btns[i].style.display = 'none';
    }

    if (remain > 0) {
      const next = `+${remain} more`;
      if (moreEl.textContent !== next) moreEl.textContent = next;
      moreEl.style.display = '';
    } else {
      if (moreEl.style.display !== 'none') moreEl.style.display = 'none';
      if (moreEl.textContent) moreEl.textContent = '';
    }
  }

  function setAtcState(card, variant) {
    // ✅ multi-option 상품은 ATC 상태/라벨을 JS가 만지지 않음
    if (isMultiOptionProduct(card)) return;

    const btn = qs(card, '[data-ps-atc-btn]');
    if (!btn) return;

    const available = variant ? !!variant.available : true;
    btn.disabled = !available;

    const soldOutLabel = btn.getAttribute('data-ps-label-soldout') || 'Sold out';
    const addLabel = btn.getAttribute('data-ps-label-add') || 'Add to cart';

    const next = available ? addLabel : soldOutLabel;
    if (btn.textContent !== next) btn.textContent = next;
  }

  function initWishlist(card) {
    const btns = qsa(card, '[data-ps-wish]');
    for (let i = 0; i < btns.length; i++) {
      const btn = btns[i];
      if (btn.dataset.psWishInited === '1') continue;
      btn.dataset.psWishInited = '1';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        btn.classList.toggle('is-on');
      });
    }
  }

  // variants map (id -> variant)
  function parseVariantsMap(card) {
    const script = qs(card, '[data-ps-variants]');
    if (!script) return null;

    try {
      const arr = JSON.parse(script.textContent || '[]');
      if (!Array.isArray(arr) || !arr.length) return null;

      const map = new Map();
      for (let i = 0; i < arr.length; i++) {
        const v = arr[i];
        if (v && v.id != null) map.set(String(v.id), v);
      }
      return map;
    } catch (e) {
      return null;
    }
  }

  function getVariantImageUrl(v) {
    if (!v) return '';
    if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    if (typeof v.image === 'string') return v.image;
    if (v.image && v.image.src) return v.image.src;
    return '';
  }

  // --- Shopify image helpers (keep srcset for perf) -------------------------
  function normalizeShopifyImgUrl(url) {
    let u = (url || '').trim();
    if (!u) return '';
    if (u.startsWith('//')) u = 'https:' + u;

    // query 제거 (width= 등)
    const qIndex = u.indexOf('?');
    if (qIndex !== -1) u = u.slice(0, qIndex);

    // 파일명 뒤의 _{WxH}, _{W}x, _x{H} 같은 size suffix 제거
    u = u.replace(/_(\d+)?x(\d+)?(?=\.(png|jpe?g|webp|avif|gif)$)/i, '');

    return u;
  }

  function buildShopifySizedUrl(baseUrl, width) {
    if (!baseUrl) return '';
    const sep = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${sep}width=${width}`;
  }

  function buildSrcset(baseUrl, widths) {
    const list = [];
    for (let i = 0; i < widths.length; i++) {
      const w = widths[i];
      const u = buildShopifySizedUrl(baseUrl, w);
      if (u) list.push(`${u} ${w}w`);
    }
    return list.join(', ');
  }

  function getImgNaturalWidth(imgEl) {
    const wAttr = parseInt(imgEl.getAttribute('width') || '0', 10);
    if (wAttr) return wAttr;
    const rect = imgEl.getBoundingClientRect();
    return rect && rect.width ? Math.round(rect.width) : 0;
  }

  function initSwatches(card) {
    const wrap = qs(card, '[data-ps-swatches]');
    const variantIdInput = qs(card, 'form[data-ps-atc] input[name="id"][data-ps-variant-input]');
    if (!wrap || !variantIdInput) return;

    const btns = qsa(wrap, '[data-ps-swatch]');
    if (!btns.length) return;

    if (card.dataset.psSwatchesInited === '1') {
      layoutSwatchesByWidth(card);
      return;
    }
    card.dataset.psSwatchesInited = '1';

    const variantsMap = parseVariantsMap(card);
    const cardImg = qs(card, '.ps-card__img--primary') || qs(card, '.ps-card__img');

    function setActive(btn) {
      for (let i = 0; i < btns.length; i++) {
        const b = btns[i];
        const on = b === btn;
        if (b.classList.contains('is-active') !== on) b.classList.toggle('is-active', on);
      }
    }

    function setVariantId(id) {
      if (!id) return;
      const next = String(id);
      if (variantIdInput.value !== next) variantIdInput.value = next;
    }

    // ✅ srcset 제거하지 말고 src/srcset/sizes 갱신
    function setCardImage(url) {
      if (!cardImg || !url) return;

      const base = normalizeShopifyImgUrl(url);
      if (!base) return;

      const renderedW = getImgNaturalWidth(cardImg) || 360;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const target = Math.min(Math.round(renderedW * dpr), 1100);

      const nextSrc = buildShopifySizedUrl(base, target);

      if (cardImg.getAttribute('src') === nextSrc) return;

      const widths = [165, 240, 360, 540, 750, 940, 1100];
      const nextSrcset = buildSrcset(base, widths);

      cardImg.setAttribute('src', nextSrc);

      if (!cardImg.getAttribute('sizes')) {
        cardImg.setAttribute('sizes', '(max-width: 749px) 50vw, 25vw');
      }

      cardImg.setAttribute('srcset', nextSrcset);

      cardImg.style.opacity = '0.001';
      requestAnimationFrame(() => {
        cardImg.style.opacity = '';
      });
    }

    function apply(btn) {
      const id = btn.getAttribute('data-ps-variant-id');
      if (!id) return;

      setVariantId(id);

      const v = variantsMap ? variantsMap.get(String(id)) : null;

      const directCardImg = btn.getAttribute('data-ps-card-img');
      if (directCardImg) setCardImage(directCardImg);
      else {
        const img = getVariantImageUrl(v);
        if (img) setCardImage(img);
      }

      setActive(btn);
      setAtcState(card, v);
    }

    for (let i = 0; i < btns.length; i++) {
      const btn = btns[i];
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        apply(btn);
      });
    }

    // initial
    apply(btns[0]);
    layoutSwatchesByWidth(card);
  }

  // ✅ multi-option 상품 CTA를 “상품 페이지 이동”으로 강제
  function initMultiOptionCta(card) {
    if (!isMultiOptionProduct(card)) return;

    const btn = qs(card, '[data-ps-atc-btn]');
    if (!btn) return;

    if (btn.dataset.psCtaInited === '1') return;
    btn.dataset.psCtaInited = '1';

    const url = btn.getAttribute('data-ps-card-url') || getCardUrl(card) || '';
    if (!url) return;

    try {
      btn.setAttribute('type', 'button');
    } catch (e) {}
    btn.disabled = false;

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = url;
    });
  }

  // ✅ single-option 상품: AJAX로 담고 바로 /cart 이동
  function initAjaxAtcRedirect(card) {
    if (isMultiOptionProduct(card)) return;

    const form = qs(card, 'form[data-ps-atc]');
    if (!form) return;

    if (form.dataset.psAjaxAtcInited === '1') return;
    form.dataset.psAjaxAtcInited = '1';

    const btn = qs(form, '[data-ps-atc-btn]');
    const idInput = qs(form, 'input[name="id"][data-ps-variant-input]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (!idInput || !idInput.value) {
        form.submit();
        return;
      }

      if (form.dataset.psAtcBusy === '1') return;
      form.dataset.psAtcBusy = '1';

      if (btn) {
        btn.disabled = true;
        btn.classList.add('is-loading');
      }

      try {
        const fd = new FormData();
        fd.append('id', idInput.value);
        fd.append('quantity', '1');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        });

        if (!res.ok) throw new Error('add_failed');

        window.location.href = '/cart';
      } catch (err) {
        try {
          form.submit();
        } catch (e2) {
          window.location.href = '/cart';
        }
      } finally {
        if (btn) {
          btn.classList.remove('is-loading');
        }
        form.dataset.psAtcBusy = '0';
      }
    });
  }

  function initCard(card) {
    if (!card || card.dataset.psCardInited === '1') {
      if (card) layoutSwatchesByWidth(card);
      return;
    }
    card.dataset.psCardInited = '1';

    initWishlist(card);
    initSwatches(card);
    initMultiOptionCta(card);
    initAjaxAtcRedirect(card);
    layoutSwatchesByWidth(card);
  }

  function wireAll(root) {
    const cards = qsa(root || document, '[data-ps-card]');
    for (let i = 0; i < cards.length; i++) initCard(cards[i]);
  }

  let cardObserver = null;
  const canObserveCards = 'IntersectionObserver' in window;

  function wireVisible(root) {
    const cards = qsa(root || document, '[data-ps-card]');
    if (!cards.length) return;

    if (!canObserveCards) {
      wireAll(root);
      return;
    }

    if (!cardObserver) {
      cardObserver = new IntersectionObserver(
        (entries, observer) => {
          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            if (!entry.isIntersecting) continue;
            initCard(entry.target);
            observer.unobserve(entry.target);
          }
        },
        { root: null, rootMargin: '280px 0px' }
      );
    }

    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      if (!card || card.dataset.psCardInited === '1') continue;
      cardObserver.observe(card);
    }
  }

  function initDocument() {
    wireVisible(document);

    let t;
    window.addEventListener(
      'resize',
      () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const cards = qsa(document, '[data-ps-card][data-ps-card-inited="1"]');
          for (let i = 0; i < cards.length; i++) layoutSwatchesByWidth(cards[i]);
        }, 120);
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDocument);
  } else {
    initDocument();
  }

  document.addEventListener('collection:rerendered', () => wireVisible(document));
  document.addEventListener('shopify:section:load', (e) => wireVisible(e.target));
})();
